import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ShareFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M7.46 8.6C8.56 8.6 9.52 9.12 10.14 9.92L12.86 7.94C12.8 7.72 12.78 7.48 12.78 7.24C12.78 5.4 14.28 3.88 16.14 3.88C18 3.88 19.5 5.4 19.5 7.24C19.5 9.08 18 10.6 16.14 10.6C15.18 10.6 14.3 10.18 13.7 9.54L10.8 11.64C10.82 11.74 10.82 11.86 10.82 11.96C10.82 12.08 10.82 12.18 10.8 12.28L13.7 14.38C14.3 13.74 15.18 13.32 16.14 13.32C18 13.32 19.5 14.84 19.5 16.68C19.5 18.52 18 20.04 16.14 20.04C14.28 20.04 12.78 18.52 12.78 16.68C12.78 16.44 12.8 16.2 12.86 15.98L10.14 14C9.52 14.8 8.56 15.32 7.46 15.32C5.6 15.32 4.1 13.8 4.1 11.96C4.1 10.12 5.6 8.6 7.46 8.6Z" />
    </SvgIcon>
  );
});
